export const GET_NAVBAR = '@@header/GET_NAVBAR';
export const GET_NAVBAR_SUCCESS = '@@header/GET_NAVBAR_SUCCESS';
export const GET_NAVBAR_ERROR = '@@header/GET_NAVBAR_ERROR';
export const UPDATE_NAVBAR_COUNT = '@@header/UPDATE_NAVBAR_COUNT';
export const GET_NAVBAR_COUNTERS_SUCCESS = '@@header/GET_NAVBAR_COUNTERS_SUCCESS';
